export { default as General } from './General';


// WEBPACK FOOTER //
// ./src/routes/General/index.ts